import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useNicheSuspect(personId, occurrenceId) {
  const queryKey = ['nicheSuspects', personId, occurrenceId];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      try {
        return await platformApi
          .get(`niche/suspects/${personId}/${occurrenceId}`, { signal })
          .json();
      } catch (error) {
        if (error.data?.statusCode === 404) {
          return null;
        } else {
          throw error;
        }
      }
    },
    enabled: !!personId && !!occurrenceId,
    staleTime: 1000 * 60 * 60,
  });

  return { query, cancel: () => queryClient.cancelQueries({ queryKey }) };
}
